import "./LocalSeoConsultantWigan.module.css";
import Header from "@/reusable_sections/Header";
import Services from "./sections/Services";
import Editorial from "./sections/Editorial";
import Consultantbenefits from "./sections/Consultantbenefits";
import Sectors from "./sections/Sectors";
import Process from "./sections/Process";
import WiganFaq from "./sections/WiganFaq";
import Localhero from "./sections/Localhero";
import WiganAnalysis from "./sections/WiganAnalysis";
import CaseStudyShowcase from "./sections/CaseStudyShowcase";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function LocalSeoConsultantWiganPage() {
  return <div>
      <Header />
      <Services />
      <Editorial />
      <Consultantbenefits />
      <Sectors />
      <Process />
      <WiganFaq />
      <Localhero />
      <WiganAnalysis />
      <CaseStudyShowcase />
      <Consultation />
      <Footer />
    </div>;
}